var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fab-transition',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShown),expression:"isShown"}],attrs:{"color":"accent","dark":"","fab":"","fixed":"","bottom":"","right":""}},[_c('v-icon',[_vm._v("add")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }